import { useQuery } from '@tanstack/react-query';
import { apiClient } from '../client.js';

export function useProjectDashboard(projectId: string | undefined) {
  return useQuery({
    queryKey: ['projects', projectId, 'dashboard'],
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/dashboard`),
    enabled: !!projectId,
  });
}

export function useProjectGanttC(projectId: string | undefined) {
  return useQuery({
    queryKey: ['projects', projectId, 'gantt-c'],
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/gantt`),
    enabled: !!projectId,
  });
}

export function useProjectKanbanC(projectId: string | undefined) {
  return useQuery({
    queryKey: ['projects', projectId, 'kanban-c'],
    queryFn: () => apiClient.get(`/api/v1/projects/${projectId}/kanban`),
    enabled: !!projectId,
  });
}
